import { Directive, EventEmitter, HostListener, Output } from "@angular/core";
import { GridComponent, RowDragEventArgs } from "@syncfusion/ej2-angular-grids";
import { Order } from "../practice-fees/store/order/order";

@Directive({
    selector: "[ofiReorderGrid]",
    standalone: false
})
export class OfiReorderGridDirective {
  @Output() ofiRowDrop = new EventEmitter();

  constructor(private _grid: GridComponent) {}

  @HostListener("rowDrop", ["$event"]) onRowDragEventArgs(
    e: RowDragEventArgs
  ): void {
    if (e.fromIndex === e.dropIndex) return;

    const allRows = (this._grid.dataSource as {
      id: number;
      order: number;
    }[]).sort((a, b) => (a.order > b.order ? 1 : -1));
    const filteredRows = this._grid.currentViewData as {
      id: number;
      order: number;
    }[];

    const movedRow = filteredRows.find((_row, index) => index === e.fromIndex);
    const remainingFilteredRows = filteredRows.filter(
      (_row, index) => index !== e.fromIndex
    );

    const reorderedFilteredRows = [
      ...remainingFilteredRows.slice(0, e.dropIndex),
      movedRow,
      ...remainingFilteredRows.slice(e.dropIndex),
    ];

    const clonedReorderedRows = [...reorderedFilteredRows];

    const allReorderedRows = [];

    for (let i = 0; i < allRows.length; i++) {
      if (reorderedFilteredRows.find((r) => r.id === allRows[i].id)) {
        allReorderedRows.push({
          ...clonedReorderedRows.shift(),
          order: i,
        });
      } else {
        allReorderedRows.push({
          ...allRows[i],
          order: i,
        });
      }
    }

    const order: Order[] = allReorderedRows.map((t) => {
      return {
        Id: t.id,
        Order: t.order,
      };
    });

    this.ofiRowDrop.emit(order);
  }
}
